import React from 'react'
import PropTypes from 'prop-types'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

import ChromeIcon from '../icons/Chrome'
import EdgeIcon from '../icons/Edge'
import OperaIcon from '../icons/Opera'
import SettingsIcon from '@mui/icons-material/Settings'

const gridCSS = {
  height: 'calc(100vh - 160px)',
  minHeight: '10em',
}

/**
 * "Bağlan" düğmesi için Poppins ağırlığını buradan seç.
 * 100–900: Thin, ExtraLight, Light, Regular(400), Medium, SemiBold, Bold, ExtraBold, Black
 */
const POPPINS_WEIGHT = 500

const Home = (props) => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={gridCSS}
    >
      <Grid item xs={3}>
        {props.supported() ? (
          <Box sx={{ textAlign: 'center' }}>
            <Box>
              <Button
                variant="contained"
                color="success"
                size="large"
                onClick={props.connect}
                sx={{
                  m: 1,
                  fontFamily:
                    'PoppinsLocal, Poppins, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                  fontWeight: POPPINS_WEIGHT,
                  letterSpacing: 0.2,
                }}
              >
                Bağlan
              </Button>
            </Box>

            <Box>
              <Button
                size="large"
                onClick={props.openSettings}
                sx={{ m: 1, color: '#bebebe' }}
              >
                <SettingsIcon />
              </Button>
            </Box>

            <Alert severity="info" sx={{ textAlign: 'left' }}>
              1. Bağlan&#39;a tıklayınız<br />
              2. Cihazınızı bağlayınız ve port&#39;u seçiniz<br />
              3. Seri terminali kullanabilirsiniz<br />
            </Alert>
          </Box>
        ) : (
          <Alert severity="warning">
            <AlertTitle>Tarayıcınız seri terminali desteklemiyor.</AlertTitle>
            Lütfen&nbsp;
            <a href="https://www.google.com/chrome/" target="blank">
              <ChromeIcon fontSize="inherit" /> <b>Chrome</b>
            </a>
            ,&nbsp;
            <a href="https://www.microsoft.com/en-us/edge" target="blank">
              <EdgeIcon fontSize="inherit" /> <b>Edge</b>
            </a>
            , veya&nbsp;
            <a href="https://www.opera.com/" target="blank">
              <OperaIcon fontSize="inherit" /> <b>Opera</b>
            </a>
            &nbsp;ile deneyiniz.
            <br />
            (IOS & Android tarayıcılar desteklenmemektedir.)
            <br />
          </Alert>
        )}
      </Grid>
    </Grid>
  )
}

Home.propTypes = {
  connect: PropTypes.func,
  supported: PropTypes.func,
  openSettings: PropTypes.func,
}

export default Home
